module.exports = __webpack_public_path__ + "img/ticimax-logo.c52a2e6d.svg";